/**
 * @generated SignedSource<<40f9df84fe0a585a9c1d9df6714a6bc7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type renderChildRows_nativeIssueTable_RenderChildRowsComp_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"rows_jiraProject">;
  readonly " $fragmentType": "renderChildRows_nativeIssueTable_RenderChildRowsComp_project";
};
export type renderChildRows_nativeIssueTable_RenderChildRowsComp_project$key = {
  readonly " $data"?: renderChildRows_nativeIssueTable_RenderChildRowsComp_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"renderChildRows_nativeIssueTable_RenderChildRowsComp_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "renderChildRows_nativeIssueTable_RenderChildRowsComp_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "rows_jiraProject"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "76253f9f92c0c4a3dc660bd3fb584942";

export default node;
